import { createBrowserRouter } from "react-router-dom";
import Home from "../pages/customer/Home";
import RootLayoutCustomer from "../components/customer/RootLayoutCustomer";
import SuccessMessage from "../components/shared/SuccessMessage";
import ErrorBlock from "../components/shared/ErrorBlock";
import NotFound from "../pages/NotFound.js";

export const customerRouter = createBrowserRouter([
   {
      path: "/:shopName",  // Dynamische shopnaam
      element: <RootLayoutCustomer />,
      children: [
         {
            index: true,
            element: <Home />,
         },
         {
            path: "betaling-succes",  // Dynamisch pad blijft behouden
            element: <SuccessMessage 
               title={"Je betaling is gelukt"} 
               description={"Bedankt voor je betaling! Neem contact met ons op als je vragen hebt."}>
            </SuccessMessage>
         },
         {
            path: "betaling-gestopt",
            element: <ErrorBlock 
               title={"Betaling geannuleerd"} 
               message={"Het lijkt erop dat je de betaling hebt geannuleerd. Geen zorgen, je kunt het opnieuw proberen of contact met ons opnemen voor hulp."}>
            </ErrorBlock>
         }
      ],
   },
   {
      path: "*",
      element: <NotFound />
   }
]);
